import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Today } from "@material-ui/icons";
import moment from "moment";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import useStyles from "../../styles";
import CobeeDatePicker from "../../../../../CobeeDatePicker";

export default function RowDate({
  date,
  setDate,
}: {
  date: Date;
  setDate(e: any): void;
}): JSX.Element {
  const { secondColumn, datepicker } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.payroll-substraction-start-date")}: <br />
          {t("request-section.payroll-substraction-message")}
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <CobeeDatePicker
          adaptToContainer={false}
          showMonthYearPicker
          minDate={moment(new Date())
            .add(1, "months")
            .startOf("month")
            .toDate()}
          selectedDate={date}
          onChange={setDate}
          customInput={
            <div className={datepicker}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                item
                xs={12}
              >
                <Typography variant="caption">
                  {moment(date).format("MMMM YYYY")}
                </Typography>
                <Today />
              </Grid>
            </div>
          }
        />
      </Grid>
    </>
  );
}
